import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
export function duplicateSkillValidator(formArray: AbstractControl): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('skill_id')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('skill_id')?.setErrors({ duplicateSkill: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('skill_id')?.setErrors(null);
    }
  }
  return null;
}
export function duplicateavailabilityValidator(formArray: AbstractControl): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('availability')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('availability')?.setErrors({ duplicateavailability: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('availability')?.setErrors(null);
    }
  }
  return null;
}
export function duplicatelanguesValidator(formArray: AbstractControl): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('language')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('language')?.setErrors({ duplicatelanguage: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('language')?.setErrors(null);
    }
  }
  return null;
}

export function duplicateYearExpValidator(
  formArray: AbstractControl
): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('year_experience')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('year_experience')?.setErrors({ duplicateYearExp: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('year_experience')?.setErrors(null);
    }
  }
  return null;
}
@Component({
  selector: 'app-compare-candidats',
  templateUrl: './compare-candidats.component.html',
  styleUrls: ['./compare-candidats.component.css'],
})
export class CompareCandidatsComponent {
  BaremeForm: FormGroup = this.createBaremeForm();
  formData = new FormData();
  jobId: any;
  companyType: any;
  currentUser: any;
  idclientConnected = this.localStorageService.getData('clientConnected');
  candidate_ids!: any[];
  skillsList: { name_FR: string }[] = [];
  private unsubscribeAll: Subject<void> = new Subject();
  disponibilite = [
    { id: 1, name: 'Immédiate', value: '1' },
    { id: 2, name: '2 mois', value: '2' },
    { id: 3, name: '3 mois', value: '3' },
    { id: 4, name: '4 mois', value: '4' },
    { id: 5, name: '5 mois', value: '5' },
  ];
  languages = [
    { id: 1, name: 'Abkhaze' },
    { id: 2, name: 'Afrikaans' },
    { id: 3, name: 'Albanais' },
    { id: 4, name: 'Allemand' },
    { id: 5, name: 'Amharique' },
    { id: 6, name: 'Anglais' },
    { id: 7, name: 'Arabe' },
    { id: 8, name: 'Arménien' },
    { id: 9, name: 'Assamais' },
    { id: 10, name: 'Aymara' },
    { id: 11, name: 'Azéri' },
    { id: 12, name: 'Basque' },
    { id: 13, name: 'Bengali' },
    { id: 14, name: 'Biélorusse' },
    { id: 15, name: 'Birman' },
    { id: 16, name: 'Bosniaque' },
    { id: 17, name: 'Bulgare' },
    { id: 18, name: 'Catalan' },
    { id: 19, name: 'Cebuano' },
    { id: 20, name: 'Chewa' },
    { id: 21, name: 'Chichewa' },
    { id: 22, name: 'Chinois' },
    { id: 23, name: 'Coréen' },
    { id: 24, name: 'Corse' },
    { id: 25, name: 'Croate' },
    { id: 26, name: 'Danois' },
    { id: 27, name: 'Dzongkha' },
    { id: 28, name: 'Espagnol' },
    { id: 29, name: 'Estonien' },
    { id: 30, name: 'Finnois' },
    { id: 31, name: 'Flamand' },
    { id: 32, name: 'Français' },
    { id: 33, name: 'Frison' },
    { id: 34, name: 'Gaélique' },
    { id: 35, name: 'Galicien' },
    { id: 36, name: 'Géorgien' },
    { id: 37, name: 'Grec' },
    { id: 38, name: 'Groenlandais' },
    { id: 39, name: 'Gujarati' },
    { id: 40, name: 'Haoussa' },
    { id: 41, name: 'Hébreu' },
    { id: 42, name: 'Hindi' },
    { id: 43, name: 'Hmong' },
    { id: 44, name: 'Hongrois' },
    { id: 45, name: 'Ibo' },
    { id: 46, name: 'Islandais' },
    { id: 47, name: 'Indonésien' },
    { id: 48, name: 'Inuktitut' },
    { id: 49, name: 'Italien' },
    { id: 50, name: 'Japonais' },
    { id: 51, name: 'Javanais' },
    { id: 52, name: 'Kannada' },
    { id: 53, name: 'Kashmiri' },
    { id: 54, name: 'Kazakh' },
    { id: 55, name: 'Khmer' },
    { id: 56, name: 'Kinyarwanda' },
    { id: 57, name: 'Kirghize' },
    { id: 58, name: 'Kirundi' },
    { id: 59, name: 'Kurde' },
    { id: 60, name: 'Laotien' },
    { id: 61, name: 'Latin' },
    { id: 62, name: 'Letton' },
    { id: 63, name: 'Lituanien' },
    { id: 64, name: 'Luxembourgeois' },
    { id: 65, name: 'Macédonien' },
    { id: 66, name: 'Malais' },
    { id: 67, name: 'Malayalam' },
    { id: 68, name: 'Malgache' },
    { id: 69, name: 'Maltais' },
    { id: 70, name: 'Maori' },
    { id: 71, name: 'Marathi' },
    { id: 72, name: 'Mongol' },
    { id: 73, name: 'Néerlandais' },
    { id: 74, name: 'Népalais' },
    { id: 75, name: 'Norvégien' },
    { id: 76, name: 'Ouzbek' },
    { id: 77, name: 'Pachtou' },
    { id: 78, name: 'Papiamento' },
    { id: 79, name: 'Pashto' },
    { id: 80, name: 'Persan (farsi)' },
    { id: 81, name: 'Polonais' },
    { id: 82, name: 'Portugais' },
    { id: 83, name: 'Punjabi' },
    { id: 84, name: 'Quechua' },
    { id: 85, name: 'Roumain' },
    { id: 86, name: 'Russe' },
    { id: 87, name: 'Somali' },
    { id: 88, name: 'Samoan' },
    { id: 89, name: 'Sanskrit' },
    { id: 90, name: 'Serbe' },
    { id: 91, name: 'Sesotho' },
    { id: 92, name: 'Shona' },
    { id: 93, name: 'Sindhi' },
    { id: 94, name: 'Slovaque' },
    { id: 95, name: 'Slovène' },
    { id: 96, name: 'Sotho' },
    { id: 97, name: 'Soundanais' },
    { id: 98, name: 'Suédois' },
    { id: 99, name: 'Swahili' },
    { id: 100, name: 'Tadjik' },
  ];

  expYears = [
    { id: 1, name: '0-1', value: '1' },
    { id: 2, name: '1-2', value: '2' },
    { id: 3, name: '2-5', value: '3' },
    { id: 4, name: '5-10', value: '4' },
    { id: 5, name: '+10', value: '5' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private jobOfferService: EsnJobOfferService,
    private salarieService: SalarieService,
    private localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.getListSkills();
    this.getId();
    this.getcurrentUser();
    this.loadSkillsFromLocalStorage();
  }
  /* get id  from route */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        const idsString = params.params['candidatsIds'];
        this.candidate_ids = idsString ? idsString.split(',') : [];        
      },
    });
  }
  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyType = JSON.parse(this.currentUser).company.type;
  }
cancelScale(){
    this.router.navigate([
      `/candidats/list-candidats`,
    ]);
  }
   checkInputsDuplication(): boolean{
    return this.hasDuplicateSkillErrors() || this.hasDuplicateavaibilityErrors()|| 
    this.hasDuplicatelangueErrors() || this.hasDuplicateExpYearsErrors()
  }
  createFormLangues(data?: any): FormGroup {
    const formGroup =this.formBuilder.group({
      language: [data ? data.language : null],
      coef: [{ value: data ? String(data.coef) : null, disabled: true }, Validators.required]
    });
    formGroup.get('language')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }
  isFormValid(): boolean {
    // Validation pour chaque groupe de contrôles
    const skillsValid = this.skillsControls.some(control => {
      const skillSelected = control.get('skill_id')?.value;
      const coefFilled = control.get('coef')?.value;
      return skillSelected && coefFilled !== null && coefFilled !== '';
    });
  
    const availabilityValid = this.availability_scoresControls.some(control => {
      const availabilitySelected = control.get('availability')?.value;
      const coefFilled = control.get('coef')?.value;
      return availabilitySelected && coefFilled !== null && coefFilled !== '';
    });
  
    const experienceValid = this.yearExpControls.some(control => {
      const yearExperience = control.get('year_experience')?.value;
      const coefFilled = control.get('coef')?.value;
      return yearExperience && coefFilled !== null && coefFilled !== '';
    });
  
    const languageValid = this.langueControls.some(control => {
      const languageSelected = control.get('language')?.value;
      const coefFilled = control.get('coef')?.value;
      return languageSelected && coefFilled !== null && coefFilled !== '';
    });
  
    const testQCMScore = this.BaremeForm.get('test_qcm_score')?.value;
    const isTestQCMScoreValid = testQCMScore !== null && testQCMScore !== '';
  
    // Vérifier que toutes les saisies qui ont des valeurs ont des coefs valides
    const areAllCoefficientsValid = [
      ...this.skillsControls,
      ...this.availability_scoresControls,
      ...this.yearExpControls,
      ...this.langueControls
    ].every(control => {
      const coefControl = control.get('coef');
      const valueControl = control.get('skill_id')?.value || control.get('availability')?.value || control.get('year_experience')?.value || control.get('language')?.value;
      // Si une valeur est entrée, le coefficient doit être non nul et non vide
      return valueControl ? coefControl?.value !== null && coefControl?.value !== '' : true;
    });
  
    // Le formulaire est valide si au moins une section est remplie correctement et tous les coefficients requis sont présents
    return (
      (skillsValid || availabilityValid || experienceValid || languageValid || isTestQCMScoreValid) &&
      areAllCoefficientsValid
    );
  }
  
  
  
  
  
  createFormSkills(data?: any): FormGroup {
    const formGroup = this.formBuilder.group({
      skill_id: [data ? data.skill_id : null, Validators.required],
      coef: [{ value: data ? String(data.coef) : null, disabled: true }, Validators.required]
    });

    formGroup.get('skill_id')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }
  
  createFormAvailability(data?: any) : FormGroup{
    const formGroup =  this.formBuilder.group({
      availability: [data ? data.availability : null,Validators.required],
      coef: [{ value: data ? String(data.coef) : null, disabled: true }, Validators.required]
    });
    formGroup.get('availability')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
    
  }
  createFormExperience(data?: any):FormGroup {
    const formGroup = this.formBuilder.group({
      year_experience: [data ? String(data.year_experience) : null],
      coef: [{ value: data ? String(data.coef) : null, disabled: true }, Validators.required]
    });
    formGroup.get('year_experience')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }

  addSkills() {
    const skills = this.BaremeForm.get('skill_scores') as FormArray;
    skills.push(this.createFormSkills());
  }
  addLangues() {
    const language_scores = this.BaremeForm.get('language_scores') as FormArray;
    language_scores.push(this.createFormLangues());
  }
  addAvailability() {
    const availability_scores = this.BaremeForm.get(
      'availability_scores'
    ) as FormArray;
    availability_scores.push(this.createFormAvailability());
  }
  addYearExp() {
    const experience_scores = this.BaremeForm.get(
      'experience_scores'
    ) as FormArray;
    experience_scores.push(this.createFormExperience());
  }

  get skillsControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('skill_scores') as FormArray)?.controls || [];
  }
  get availability_scoresControls(): AbstractControl<any, any>[] {
    return (
      (this.BaremeForm.get('availability_scores') as FormArray)?.controls || []
    );
  }
  get langueControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('language_scores') as FormArray)?.controls || [];
  }

  get yearExpControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('experience_scores') as FormArray)?.controls || [];
  }
  removescoreQCM(index: number) {
    const ScoreQCM = this.BaremeForm.get('test_qcm_score') as FormArray;
    ScoreQCM.removeAt(index);
  }
  removeSkills(index: number) {
    const skills = this.BaremeForm.get('skill_scores') as FormArray;
    skills.removeAt(index);
  }
  removeAvailability(index: number) {
    const availability_scores = this.BaremeForm.get(
      'availability_scores'
    ) as FormArray;
    availability_scores.removeAt(index);
  }
  removeLangue(index: number) {
    const language_scores = this.BaremeForm.get('language_scores') as FormArray;
    language_scores.removeAt(index);
  }
  removeYearExp(index: number) {
    const year_exp_score = this.BaremeForm.get('experience_scores') as FormArray;
    year_exp_score.removeAt(index);
  }
  createBaremeForm(data?: any) {
    const companyType = this.companyType;
    const skillScoreArray = this.formBuilder.array(
      Array.isArray(data?.skill_scores) && data?.skill_scores.length
        ? data.skill_scores.map((item: any) => this.createFormSkills(item))
        : [this.createFormSkills()]
    );
  
    // Ajout de la validation pour les compétences dupliquées
    skillScoreArray.setValidators(duplicateSkillValidator);
    const skillavaibilityArray = this.formBuilder.array(
      Array.isArray(data?.availability_scores) && data?.availability_scores.length
        ? data.availability_scores.map((item: any) => this.createFormAvailability(item))
        : [this.createFormAvailability()]
    );
  

    skillavaibilityArray.setValidators(duplicateavailabilityValidator);

    const skilllanguersArray = this.formBuilder.array(
      Array.isArray(data?.language_scores) && data?.language_scores.length
        ? data.language_scores.map((item: any) => this.createFormLangues(item))
        : [this.createFormLangues()]
    );
  
    // Ajout de la validation pour les compétences dupliquées
    skilllanguersArray.setValidators(duplicatelanguesValidator);

    const skillYearExpArray = this.formBuilder.array(
      Array.isArray(data?.experience_scores) && data?.experience_scores.length
        ? data.experience_scores.map((item: any) => this.createFormExperience(item))
        : [this.createFormExperience()]
    );
    skillYearExpArray.setValidators(duplicateYearExpValidator);

    return this.formBuilder.group({
      esn_id: [companyType != 3 ? (data ? data.esn_id : '') : ''],
      client_id: [companyType == 3 ? (data ? data.client_id : '') : ''],
      test_qcm_score: data?.test_qcm_score != null ? [String(data.test_qcm_score)] : [],
      skill_scores: skillScoreArray,
      availability_scores:skillavaibilityArray,
      language_scores:skilllanguersArray,
      experience_scores: skillYearExpArray,
    });
  }
  // Helper function to convert coef values to strings
  convertCoefToString(data: any): any {
    if (data.skill_scores) {
      data.skill_scores = data.skill_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data.availability_scores) {
      data.availability_scores = data.availability_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data?.experience_scores) {
      data.experience_scores = data.experience_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data.language_scores) {
      data.language_scores = data.language_scores.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    return data;
  }
  hasDuplicateSkillErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get('skill_scores') as FormArray;
    return skillScoreArray.hasError('duplicateSkill');
  }
  hasDuplicateavaibilityErrors(): boolean {
    const skillScoreArray1 = this.BaremeForm.get('availability_scores') as FormArray;
    return skillScoreArray1.hasError('duplicateavailability');
  }
  hasDuplicatelangueErrors(): boolean {
    const skillScoreArray2 = this.BaremeForm.get('language_scores') as FormArray;
    return skillScoreArray2.hasError('duplicatelanguage');
  }

  hasDuplicateExpYearsErrors(): boolean {
    const skillScoreArray3 = this.BaremeForm.get('experience_scores') as FormArray;
    return skillScoreArray3.hasError('duplicateYearExp');
  }

  addBareme() {
    if (this.idclientConnected !== null && this.companyType != 3) {
      this.BaremeForm.patchValue({ esn_id: this.idclientConnected });
    } else {
      this.BaremeForm.patchValue({ client_id: this.idclientConnected });
    }
    let baremeData = this.BaremeForm.value;
   const experienceScore = baremeData.experience_scores;
   const skillScore = baremeData.skill_scores;
   const languageScore = baremeData.language_scores;
   const availabilityScore = baremeData.availability_scores;
   localStorage.setItem('experienceScore',JSON.stringify(experienceScore));
   localStorage.setItem('skillScore',JSON.stringify(skillScore));
   localStorage.setItem('languageScore',JSON.stringify(languageScore));
   localStorage.setItem('availabilityScore',JSON.stringify(availabilityScore));
    // Convertir les coefficients en chaînes
    baremeData = this.convertCoefToString(baremeData);
  
    // Nettoyer les tableaux en supprimant les valeurs nulles ou non valides
    baremeData.skill_scores = this.cleanArraySkills(baremeData.skill_scores);
    baremeData.availability_scores = this.cleanArrayAvailability(baremeData.availability_scores);
    baremeData.experience_scores = this.cleanArrayExperience(baremeData.experience_scores);
    baremeData.language_scores = this.cleanArrayLanguage(baremeData.language_scores);
    baremeData.candidate_ids=  this.candidate_ids;

    for (const key in baremeData) {
      if (baremeData[key] === null) {
          delete baremeData[key];
      }
  }
  
    // Envoyer les données à l'API
    this.jobOfferService.compareCandidates(baremeData)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: res => {
          if (res.status === 200) {
            this.toastrService.success('Comparaison avec succées');
            this.navigateToCompareCandidats(res);
          }
        },
        error: (err) => {
          if (
            err.error &&
            err.error.message == 'Duplicate skills values found'
          ) {
            this.toastrService.error(
              'Des compétences en double ont été détectées.'
            );
          } 
          if (
            err.error &&
            err.error.message == 'Duplicate languages values found'
          ) {
            this.toastrService.error(
              'Des languages en double ont été détectées.'
            );
          } 
        
          if (
            err.error &&
            err.error.message == 'Duplicate availabilities values found'
          ) {
            this.toastrService.error(
              'Des Disponibilités en double ont été détectées.'
            );
          }
          
        },
      });
  }
  
   loadSkillsFromLocalStorage(): void {
    const storedSkillScore = localStorage.getItem('skillScore');
    if (storedSkillScore) {
      const skillScore = JSON.parse(storedSkillScore);
      this.populateForm(skillScore);
    }

    const storedExperienceScore = localStorage.getItem('experienceScore');
    if(storedExperienceScore){
      const experienceScore = JSON.parse(storedExperienceScore);
      this.populateFormExperience(experienceScore);
    }

    const storedLanguageStore = localStorage.getItem('languageScore');
    if(storedLanguageStore){
      const languageScore = JSON.parse(storedLanguageStore);
      this.populateFormLanguage(languageScore);
    }

    const storedavailabilityScore = localStorage.getItem('availabilityScore');
    if(storedavailabilityScore) {
      const availabilityScore = JSON.parse(storedavailabilityScore);
      this.populateFormAvailability(availabilityScore);
    }
  }
 populateForm(skillScore: any[]): void {
    const formArray = this.BaremeForm.get('skill_scores') as FormArray;
    while (formArray.length !== 0) {
        formArray.removeAt(0);
    }
    skillScore.forEach(skill => {
      const existingSkillIndex = formArray.controls.findIndex(control => control.get('skill_id')?.value === skill.skill_id);
            if (existingSkillIndex >= 0) {
                formArray.at(existingSkillIndex).patchValue({
          coef: skill.coef 
                });
            } else {
                formArray.push(this.formBuilder.group({
          skill_id: [skill.skill_id, Validators.required],
          coef: [skill.coef , [Validators.min(1)]]
                }));
        }
    });
}

   populateFormExperience(experienceScore: any[]): void {
    const formArray = this.BaremeForm.get('experience_scores') as FormArray;
    while (formArray.length !== 0) {
       formArray.removeAt(0);
     }
    experienceScore.forEach(year => {
      const existingSkillIndex = formArray.controls.findIndex(control => control.get('year_experience')?.value === year.year_experience);

            if (existingSkillIndex >= 0) {
                formArray.at(existingSkillIndex).patchValue({
          coef: year.coef 
                });
            } else {
                formArray.push(this.formBuilder.group({
          year_experience: [year.year_experience, Validators.required],
          coef: [year.coef , [Validators.min(1)]]
                }));
        }
    });
  }
  populateFormLanguage(languageScore: any[]): void {
    const formArray = this.BaremeForm.get('language_scores') as FormArray;
    while (formArray.length !== 0) {
        formArray.removeAt(0);
    }
    languageScore.forEach(language => {
      const existingSkillIndex = formArray.controls.findIndex(control => control.get('language')?.value === language.language);

            if (existingSkillIndex >= 0) {
                formArray.at(existingSkillIndex).patchValue({
          coef: language.coef 
                });
            } else {
                formArray.push(this.formBuilder.group({
          language: [language.language, Validators.required],
          coef: [language.coef , [Validators.min(1)]]
                }));
        }
    });
}

  populateFormAvailability(availabilityScore: any[]): void {
    const formArray = this.BaremeForm.get('availability_scores') as FormArray;
    while (formArray.length !== 0) {
       formArray.removeAt(0);
     }
    availabilityScore.forEach(availability => {
      const existingSkillIndex = formArray.controls.findIndex(control => control.get('availability')?.value === availability.availability);

           if (existingSkillIndex >= 0) {
        formArray.at(existingSkillIndex).patchValue({
          coef: availability.coef 
        });
      } else {
        formArray.push(this.formBuilder.group({
          availability: [availability.availability, Validators.required],
          coef: [availability.coef , [Validators.min(1)]]
        }));
            }
    });
  }
  // Utility function to clean arrays
  cleanArray(array: any[]): any[] {
    if (array && Array.isArray(array)) {
      return array.filter(item => item !== null && item !== undefined && item.coef !== 'undefined');
    }
    return [];
  }
  cleanArraySkills(array: any[]): any[] {
    if (array && Array.isArray(array)) {
        return array.filter(item => 
            item !== null && 
            item !== undefined && 
            Number.isInteger(item.skill_id) && 
            item.skill_id !== null && 
            item.coef !== null && 
            Number.isInteger(Number(item.coef)) && 
            Number(item.coef) >= 1
        );
    }
    return [];
}
 cleanArrayExperience(array: any[]): any[] {
    if (array && Array.isArray(array)) {
        return array.filter(item => 
            item !== null && 
            item !== undefined && 
            typeof item.year_experience === 'string' && 
            item.year_experience !== null && 
            item.coef !== null && 
            typeof item.coef === 'string' && 
            !isNaN(Number(item.coef)) && 
            Number(item.coef) >= 1 
        );
    }
    return [];
}
  cleanArrayLanguage(array: any[]): any[] {
    if (array && Array.isArray(array)) {
        return array.filter(item => 
            item !== null && 
            item !== undefined && 
            typeof item.language === 'string' && 
            item.language !== null && 
            item.coef !== null && 
            typeof item.coef === 'string' && 
            !isNaN(Number(item.coef)) && 
            Number(item.coef) >= 1 
        );
    }
    return [];
}
  
  cleanArrayAvailability(array: any[]): any[] {
    if (array && Array.isArray(array)) {
        return array.filter(item => 
            item !== null && 
            item !== undefined && 
            typeof item.availability === 'string' && 
            item.availability !== null && 
            item.coef !== null && 
            typeof item.coef === 'string' && 
            !isNaN(Number(item.coef)) && 
            Number(item.coef) >= 1 
        );
    }
    return [];
}
  

  

  getListSkills() {
      this.spinner.show();
    this.salarieService
      .getSkillsJobs()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skillsList = res.data;
          this.spinner.hide();
        },
        error: () => {},
      });
  }

  navigateToCompareCandidats(res : any) {
    this.router.navigate(['/candidats/result-compare'], {
      state: { data : res?.data }
  });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
